import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ExpenseItem,
  type ExpenseItemConstructor,
} from '@webapp/modules/expense/entities/ExpenseItem'
import { SpendingCardConstructorFactory } from '@webapp/modules/spending-cards'
import { AccountConstructorFactory } from '@webapp/platform/finance'
import { ExpensePaymentTypes } from '../enums/ExpensePaymentTypeEnum'
import { ExpenseTypes } from '../enums/ExpenseTypeEnum'

export const ExpenseItemConstructorFactory =
  Factory.Sync.makeFactory<ExpenseItemConstructor>({
    id: Factory.each(() => faker.random.number()),
    attachment: Factory.each(() => faker.image.imageUrl()),
    merchant: Factory.each(() => faker.company.companyName()),
    account: Factory.each(() => AccountConstructorFactory.build()),
    transactionDate: Factory.each(() => faker.date.past().toISOString()),
    currency: Factory.each(() => CurrencyFactory.build()),
    reimbursable: Factory.each(() => faker.random.boolean()),
    amount: Factory.each(() => parseFloat(faker.commerce.price())),
    taxAmount: Factory.each(() => parseFloat(faker.commerce.price())),
    taxPercentage: Factory.each(() => '0.00000000'),
    taxName: Factory.each(() => '%'),
    taxId: null,
    paymentCard: Factory.each(() => SpendingCardConstructorFactory.build()),
    notes: Factory.each(() => faker.lorem.sentence()),
    expenseType: Factory.each(() => ExpenseTypes.OTHER),
    paymentType: Factory.each(() => ExpensePaymentTypes.CASH),
    expenseTypeData: Factory.each(() => ({
      type: 'OTHER' as const,
      data: null,
    })),
    mileageRatePresetId: null,
    mileageRatePresetName: null,
  })

export const ExpenseItemFactory = EntityFactory(
  ExpenseItem,
  ExpenseItemConstructorFactory
)
